export default __webpack_public_path__ + "2ba3cefc6076743d282d5bb4dde53e1b.svg";